

// src/components/RecentVideos.js
import React, { useMemo } from "react";
import { Row, Col, Pagination } from "react-bootstrap";
import { PlayCircleFill } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";

const RecentVideos = ({
  videos = [],
  currentPage: externalCurrentPage,
  totalPages: externalTotalPages,
  onPageChange: externalOnPageChange,
  videosPerPage = 6,
}) => {
  const navigate = useNavigate();
  const controlled = typeof externalCurrentPage === "number" && typeof externalOnPageChange === "function";
  const totalPagesComputed = Math.max(1, Math.ceil(videos.length / videosPerPage));
  // const totalPages = externalTotalPages || totalPagesComputed;
   const totalPages = totalPagesComputed;
  const currentPage = controlled ? externalCurrentPage : 1;

  const indexOfLast = currentPage * videosPerPage;
  const indexOfFirst = indexOfLast - videosPerPage;
  const currentVideos = videos.slice(indexOfFirst, indexOfLast);

  const handlePageChange = (page) => {
    if (controlled) {
      externalOnPageChange(page);
    } else if (typeof externalOnPageChange === "function") {
      externalOnPageChange(page);
    }

    // ✅ A11Y: announce page change for screen readers
    const msgBox = document.getElementById("pagination-status");
    if (msgBox) msgBox.textContent = `Page ${page} loaded`;
  };

  const paginationItems = useMemo(() => {
    const items = [];
    const maxVisible = 5;
    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;
    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - maxVisible + 1);
    }
    for (let p = start; p <= end; p++) {
      items.push(
        <Pagination.Item
          key={p}
          active={p === currentPage}
          onClick={() => handlePageChange(p)}
          aria-label={`Go to page ${p}`} // ✅ A11Y
        >
          {p}
        </Pagination.Item>
      );
    }
    return items;
  }, [currentPage, totalPages]);
//console.log("Thumbnail URL:", videos?.thumbnail_url);

  return (
     <div class="recent-videos-div" role="region" aria-label="recentVideosHeading">
         <div id="pagination-status" className="visually-hidden" aria-live="polite"></div>
   
         <h5   id="recentVideosHeading"
 className="mb-2 fw-bold" style={{ color: "#B0004E" }}>
           Recent videos
         </h5>
   
         {/* <Row className="g-4"> */}
         {/* <Row className="g-3"> */}
   <Row className="gx-4 gy-2" role="list">
   
           {currentVideos.map((video) => (
             <Col key={video.id} md={4} xs={12} role="listitem">
               <div
                 role="button"
                 tabIndex={0}
                 onClick={() => navigate(`/Isldescription/${video.id}`)}
              onKeyDown={(e) => e.key === "Enter" && navigate(`/Isldescription/${video.id}`)}
                 aria-label={`Play video: ${video.title}`} // ✅ A11Y
                 style={{
                   cursor: "pointer",
                   textAlign: "center",
                   display: "flex",
                   flexDirection: "column",
                   alignItems: "center",
                   outline: "none",
                 }}
               >

                
                 <div
                   style={{
                   
                     fontSize: "0.95rem",
                     fontWeight: 600,
                     color: "#333",
                     whiteSpace: "nowrap",
                     overflow: "hidden",
                     textOverflow: "ellipsis",
                     width: "100%",
                   }}
                   title={video.title}
                 >
                   {video.title}
                 </div>
   
                 <div className="video-thumb">
                  
                   {/* <img
                     src={video.thumbnail}
                     alt={`${video.title} thumbnail`} 
                     style={{
                       width: "100%",
                       height: "100%",
                       objectFit: "cover",
                     }}
                   /> */}
   {video?.thumbnail_url && (
  <img
    src={
      video.thumbnail_url.startsWith("http")
        ? video.thumbnail_url
        : `https://stagingapi.chalachitravaachana.org${video.thumbnail_url}`
    }
    alt={`${video?.name || "Video"} thumbnail`}
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
    }}
  />
)}

                   <div
                     aria-hidden="true" 
                     style={{
                       position: "absolute",
                       top: "50%",
                       left: "50%",
                       transform: "translate(-50%, -50%)",
                       zIndex: 2,
                       display: "flex",
                       alignItems: "center",
                       justifyContent: "center",
                     }}
                   >
                     <PlayCircleFill size={26} color="#fff" />
                   </div>
                 </div>

                 
                
{/*    
<div
  style={{
    marginTop: "4px",
    fontSize: "0.8rem",
    fontWeight: 600,
    width: "100%",
    textAlign: "right",
    paddingRight: "4px",
    color:
      (video.status === "Failed")
        ? "red"
        : (video.status === "Queued" ||
           video.status === "In progress" ||
           video.status === "Merging")
        ? "#8000FF"
        : "green",
  }}
  aria-label={`Status: ${
    video.status === "Merging" ? "In progress" : video.status || "Completed"
  }`}
>
  {video.status === "Merging" ? "In progress" : video.status || "Completed"}
</div> */}

                {video?.status === "Failed" && (
  <div
    style={{
      marginTop: "6px",
      fontSize: "0.8rem",
      fontWeight: 600,
      width: "100%",
      textAlign: "right",
      paddingRight: "4px",
      color: "red",
    }}
    aria-label="Status: Failed"
  >
    Failed
  </div>
)}
 
               </div>
             </Col>
           ))}
         </Row>
   
         <div style={{ display: "flex", justifyContent: "center", marginTop: 5 }}>
           <Pagination aria-label="Video page navigation"> 
             <Pagination.Prev
               onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
               disabled={currentPage === 1}
               aria-label="Go to previous page"
             />
             {paginationItems}
             <Pagination.Next
               onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
               disabled={currentPage === totalPages}
               aria-label="Go to next page" 
             />
           </Pagination>
         </div>
         
       </div>
  );
};

export default RecentVideos;
